import * as HLF from "html-living-framework";
import {IAsset} from "html-living-framework";
import {Dict} from "../core/Reflection";
import {CharacterType} from "./CharacterType";
import {LevelNumber} from "./LevelModel";
import {Location, Locations} from "./Location";

const fontGrandstander = new HLF.FontAsset("grandstander");
const backgrounds = Locations.map((it) => new HLF.TextureAsset(`background-${it}`, `images/static/background-${it}.jpg`));
const cards = Locations.map((it) => new HLF.TextureAtlasAsset(`cards-${it}-1`));

const characters = {
    [CharacterType.Luna]: new HLF.SpineAsset("luna_spine", "spine/luna@x.json"),
    [CharacterType.Andy]: new HLF.SpineAsset("andy_spine", "spine/@x/andy.json"),
    [CharacterType.Carmen]: new HLF.SpineAsset("carmen_spine", "spine/@x/carmen.json"),
    [CharacterType.Leo]: new HLF.SpineAsset("leo_spine", "spine/@x/leo.json"),
};

export const Assets = {
    boot: [
        new HLF.TextureAtlasAsset("boot-1"),
        fontGrandstander,
        new HLF.TextureAsset("background-splash", "images/static/background-splash.jpg"),
    ],
    fontGrandstander,
    common: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": 1}, (i) => new HLF.TextureAtlasAsset(`ui-${i}`)),
    ],
    characters,
    locationSelect: [
        ...backgrounds,
        ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 4]}, (i) => new HLF.TextureAtlasAsset(`location-select-${i}`)),
        characters[CharacterType.Luna],
        new HLF.AudioAsset("patw_ui08", HLF.AudioCategory.VO),
        new HLF.AudioAsset("patw_ui12", HLF.AudioCategory.VO),
    ],
    locationCommon: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": 1}, (i) => new HLF.TextureAtlasAsset(`location-common-${i}`)),
        characters[CharacterType.Luna],
    ],
    postcardPrintable: new HLF.TextureAsset("printable-background", "images/static/printable-background.png"),
    locations: {
        [Location.Rio]: [
            cards[0],
            backgrounds[0],
            ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 3]}, (i) => new HLF.TextureAtlasAsset(`location-rio-${i}`)),
        ],
        [Location.Nairobi]: [
            cards[1],
            backgrounds[1],
            ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 3]}, (i) => new HLF.TextureAtlasAsset(`location-nairobi-${i}`)),
        ],
        [Location.Munich]: [
            cards[2],
            backgrounds[2],
            ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 3]}, (i) => new HLF.TextureAtlasAsset(`location-munich-${i}`)),
        ],
        [Location.Beijing]: [
            cards[3],
            backgrounds[3],
            ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 3]}, (i) => new HLF.TextureAtlasAsset(`location-beijing-${i}`)),
        ],
        [Location.Cusco]: [
            cards[4],
            backgrounds[4],
            ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 2]}, (i) => new HLF.TextureAtlasAsset(`location-cusco-${i}`)),
        ],
        [Location.Tokyo]: [
            cards[5],
            backgrounds[5],
            ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 3]}, (i) => new HLF.TextureAtlasAsset(`location-tokyo-${i}`)),
        ],
    } as Dict<Location, Array<IAsset<any>>>,
    magicPoof: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": [1, 2]}, (i) => new HLF.TextureAtlasAsset(`magic-poof-${i}`)),
    ],
    magicGlobe: [
        ...HLF.AssetFactory({"@1x": 1, "@2x": 1}, (i) => new HLF.TextureAtlasAsset(`magic-globe-${i}`)),
    ],
    audio: {
        uiClick: new HLF.AudioAsset("ui_click", HLF.AudioCategory.SFX),
        uiSelect: new HLF.AudioAsset("ui_select", HLF.AudioCategory.SFX),
        doMatch: new HLF.AudioAsset("found", HLF.AudioCategory.SFX),
        noMatch: new HLF.AudioAsset("boing-spring", HLF.AudioCategory.SFX),
        itemRevealed: new HLF.AudioAsset("magic-chime-pop", HLF.AudioCategory.SFX),
        postcardComplete: new HLF.AudioAsset("level-success", HLF.AudioCategory.SFX),
        newPostcard: new HLF.AudioAsset("woosh-quick-2", HLF.AudioCategory.SFX),
        postcardSlide: new HLF.AudioAsset("paper-slide", HLF.AudioCategory.SFX),
        trumpet: new HLF.AudioAsset("trumpet", HLF.AudioCategory.SFX),
        drums: new HLF.AudioAsset("drums", HLF.AudioCategory.SFX),
        spin: new HLF.AudioAsset("fuujin-air-gust", HLF.AudioCategory.SFX),
        envelopeOpen: new HLF.AudioAsset("book-open", HLF.AudioCategory.SFX),
        envelopeClick: new HLF.AudioAsset("chime-fade", HLF.AudioCategory.SFX),
        tileClick: new HLF.AudioAsset("tile-click", HLF.AudioCategory.SFX),
        bgm: {
            menu: new HLF.AudioAsset("LATW 662 happy pacer hollywood japan AP_longer", HLF.AudioCategory.BGM),
            [Location.Beijing]: new HLF.AudioAsset("LATW 288 pretty majestic pacer drums china KK", HLF.AudioCategory.BGM),
            [Location.Cusco]: new HLF.AudioAsset("LATW 1118 light happy pacer gliss peru AP_longer", HLF.AudioCategory.BGM),
            [Location.Munich]: new HLF.AudioAsset("LATW 1005 happy pacer glock germany KK_longer", HLF.AudioCategory.BGM),
            [Location.Nairobi]: {
                1: new HLF.AudioAsset("LATW 1067 majestic happy pacer lion king kenya AP", HLF.AudioCategory.BGM),
                2: new HLF.AudioAsset("LATW 1056 happy pacer sad benga kenya KK_longer", HLF.AudioCategory.BGM),
            },
            [Location.Rio]: {
                1: new HLF.AudioAsset("LATW 940 happy pacer brazil AP", HLF.AudioCategory.BGM),
                2: new HLF.AudioAsset("LATW 953 happy pacer think mark samba brazil AP_tweaked", HLF.AudioCategory.BGM),
            },
            [Location.Tokyo]: new HLF.AudioAsset("LATW 682 pretty pacer japan KK_longer", HLF.AudioCategory.BGM),
        } as { menu: HLF.AudioAsset } & Dict<Location, HLF.AudioAsset | Dict<LevelNumber, HLF.AudioAsset>>,
    },
};

export const LibraryAssets = [
    ...Assets.common,
    ...Assets.locationSelect,
    Assets.audio.uiClick,
    Assets.audio.spin,
    Assets.audio.newPostcard,
    Assets.audio.envelopeClick,
];

export const PostcardAssets = [
    ...Assets.common,
    ...Assets.magicPoof,
    ...Assets.locationCommon,
    Assets.postcardPrintable,
    Assets.audio.uiClick,
    Assets.audio.uiSelect,
    Assets.audio.doMatch,
    Assets.audio.noMatch,
    Assets.audio.itemRevealed,
    Assets.audio.postcardComplete,
    Assets.audio.postcardSlide,
    Assets.audio.envelopeOpen,
    Assets.audio.tileClick,
    Assets.audio.envelopeClick,
];

export const FreePlayAssets = [
    ...Assets.common,
    ...Assets.locationCommon,
    ...cards,
    characters[CharacterType.Luna],
    Assets.audio.uiClick,
    Assets.audio.uiSelect,
    Assets.audio.doMatch,
    Assets.audio.noMatch,
    Assets.audio.itemRevealed,
    Assets.audio.postcardComplete,
    Assets.audio.tileClick,
    Assets.audio.envelopeClick,
];

export function getBgmAsset(data: { location: Location, level: LevelNumber }) {
    const bgmAsset = Assets.audio.bgm[data.location]!;
    return bgmAsset instanceof HLF.AudioAsset ? bgmAsset : bgmAsset[data.level]!;
}

export function getLocationBackgroundAsset(location: Location) {
    return backgrounds[Locations.indexOf(location)];
}
